module.exports = __webpack_public_path__ + "static/media/blue-diamond-logo.e3ae1f53.png";